// composables/useDeviceId.ts
export function useDeviceId() {
    const deviceIdKey = 'deviceId'

    const getDeviceId = () => {
        let deviceId = localStorage.getItem(deviceIdKey)
        if (!deviceId) {
            deviceId = crypto.randomUUID()
            localStorage.setItem(deviceIdKey, deviceId)
        }
        return deviceId
    }

    return {
        deviceId: getDeviceId(),
    }
}